import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { BarVerticalStackedComponent, NgxChartsModule } from '@swimlane/ngx-charts';
import { lastValueFrom } from 'rxjs';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { PipelineRunsService } from '../services/pipelineruns.service';
import { Color, ScaleType } from '@swimlane/ngx-charts';


@Component({
  selector: 'app-analytics',
  standalone: true,
  imports: [
    NgxChartsModule,
    MatCardModule,
    MatDividerModule
  ],
  templateUrl: './analytics.component.html',
  styleUrl: './analytics.component.scss'
})

export class AnalyticsComponent implements OnInit {

  @ViewChild('dailyExecutionChart') executionChart!: BarVerticalStackedComponent; 

  // Definições do ngx-charts
  view: [number, number] = [700, 400]; // Largura e altura do gráfico
  colorScheme: string = 'vivid';

  customColorScheme: Color = { 
    domain: ['#4CAF50', '#F44336'], 
    group: ScaleType.Ordinal, 
    selectable: true, 
    name: 'Daily Usage', 
  };

  // Dados formatados para o ngx-charts
  chartDataVolume: any[] = [];
  chartDataRate: any[] = [];
  maxExecutions: number = 40;
  maxFailureRate: number = 100;

  constructor(
    private pipelineRunsService: PipelineRunsService) { }

  async ngOnInit() {
    let response = await lastValueFrom(this.pipelineRunsService.getStatuses());
    let dataArray = [];
    if(response != null) {
      if (response.data != null) {
        dataArray = response.data;
      }
    }
    this.processApiData(dataArray);
  }

  processApiData(data: any[]) {
    // Para o Gráfico de Linha (Taxa de Falha): requer apenas uma série de pontos
    const rateSeries = { name: 'Failure Rate', series: [] as any[] };
    
    // Para o Gráfico de Barras Empilhadas (Volume): requer um array onde cada item é uma barra (data)
    const volumeChartData: any[] = [];

    let maxTotal = 0;

    // O ngx-charts espera datas em ordem crescente, mas a API está em decrescente.
    // Invertemos a ordem da API para exibir corretamente no eixo X.
    const sortedData = [...data].sort((a, b) => {
        return new Date(a.this_date).getTime() - new Date(b.this_date).getTime();
    });

    for (const item of sortedData) {
        // Extrai apenas a data (YYYY-MM-DD) e garante a conversão para número
        const date = new Date(item.this_date).toISOString().substring(0, 10);
        const errors = parseInt(item.error_rate, 10);
        const successes = parseInt(item.success_rate, 10);
        const total = errors + successes;
        const rate = total > 0 ? (errors / total) * 100 : 0;

        // 1. Dados para o Gráfico de Barras Empilhadas (Volume)
        // Estrutura CORRETA: O 'name' é a Data (Eixo X) e o 'series' contém os valores a serem empilhados.
        volumeChartData.push({
            name: date, 
            series: [
                { name: 'Successes', value: successes },
                { name: 'Errors', value: errors }
            ]
        });

        // 2. Dados para a Taxa (Gráfico de Linha)
        rateSeries.series.push({ name: date, value: rate });

    }
    
    // Atribui os dados formatados
    this.chartDataVolume = volumeChartData;
    this.chartDataRate = [rateSeries];
  }
}
